module.exports = __webpack_public_path__ + "media/account-background.3ea937d1.mp4";